import React, { memo, ChangeEvent } from 'react'
import { IShipperRate } from 'apps/rms/types/shipperRates'
import { TextInput } from 'components/atoms'

interface IExistingAwardProps {
  value: RecursivePartial<IShipperRate>
  onChange: (change: RecursivePartial<IShipperRate>) => void
  error?: string
}

export const ExistingAward = memo<IExistingAwardProps>(
  ({ error, onChange, value: { existingAwardId } }) => {
    const updateShipperHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
      onChange({
        existingAwardId: value,
      })
    }

    return (
      <div className='col-md-4 col-xs-4'>
        <TextInput
          label='Existing Award ID'
          placeholder='Enter existing award id'
          value={existingAwardId || undefined}
          onChange={updateShipperHandler}
          type='text'
          id='shipper-rates-exisiting-award-id'
          dataTest='modal-existing-award-id'
          required
          validationMessage={error}
          invalid={!!error}
        />
      </div>
    )
  }
)
